import Container, { ContainerProps } from '@mui/material/Container';
const MuiContainer = (props: ContainerProps) => {
  return <Container maxWidth='xl' {...props}/>;
};
export default MuiContainer;
